import dayjs from 'dayjs';
import { services } from '@/shared/plugins/services';

const hasActiveScheduleWithType = (schedule, type) => {
  const now = services.resolve('time').now;
  if (!schedule.till) {
    return schedule.type === type && now.valueOf() > dayjs(schedule.since).valueOf();
  }

  if (schedule.type === type) {
    return now.valueOf() >= dayjs(schedule.since).valueOf()
      && now.valueOf() <= dayjs(schedule.till).valueOf();
  }
};

const getActiveScheduleByType = (product, type) => {
  const displaySchedules = product.displaySchedules;
  if (displaySchedules) {
    return displaySchedules.find((schedule) => hasActiveScheduleWithType(schedule, type));
  }
};

export default getActiveScheduleByType;
